import React from 'react';
import { useAlert } from 'react-alert'

const App = (props) => {
    
    const alert = useAlert()
    return (
      <button id="Alertmsgbtn"  style={{display:"none"}}
        onClick={() => {
          alert.show(props.alertmsg)
        }}
      >
        Show Alert
      </button>
    )
  }
  
  export default App